import { useCallback } from 'react';

import Key from '../../models/Engines/Key';
import EnginesService from '../../services/EnginesService';
import ErrorResponse from '../../types/ErrorResponse';
import ItemResponse from '../../types/ItemResponse';
import useItemQuery from '../useItemQuery';

const useEnginesCopyrightKeyQuery = () => {
	const fetcher = useCallback(
		async (
			dataSetter: (data: ItemResponse<Key>) => void,
			errorSetter: (error: ErrorResponse) => void,
			domain: string,
		) => {
			await new EnginesService().copyrightKey(domain, dataSetter, errorSetter);
		},
		[],
	);

	return useItemQuery(fetcher);
};

export default useEnginesCopyrightKeyQuery;
